export default __webpack_public_path__ + "static/media/face_guid.3fe62461.webp";